import React from "react";

interface PastOrderRowProps {
  orderId: string;
  date: string;
  status: string;
  onClick?: () => void;
}

export const PastOrderRow: React.FC<PastOrderRowProps> = ({
  orderId,
  date,
  status,
  onClick,
}) => (
  <div
    className="flex items-center justify-between px-4 py-1 cursor-pointer active:bg-gray-50 transition-colors"
    onClick={onClick}
  >
    {/* Left: Icon + Order info */}
    <div className="flex items-center gap-3">
      <div className="w-10 h-10 rounded-xl bg-[#44B6CE]/10 flex items-center justify-center flex-shrink-0">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#44B6CE" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/>
          <polyline points="14 2 14 8 20 8"/>
          <line x1="16" y1="13" x2="8" y2="13"/>
          <line x1="16" y1="17" x2="8" y2="17"/>
          <polyline points="10 9 9 9 8 9"/>
        </svg>
      </div>
      <div>
        <p className="text-sm font-bold text-gray-900 leading-tight">{orderId}</p>
        <p className="text-xs text-gray-400 mt-0.5">{date || "—"}</p>
      </div>
    </div>

    {/* Right: Status badge + chevron */}
    <div className="flex items-center gap-2">
      <span className="text-xs font-semibold text-green-600 bg-green-50 px-3 py-1 rounded-full">
        {status}
      </span>
      <div className="w-7 h-7 rounded-full bg-[#44B6CE]/10 flex items-center justify-center">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#44B6CE" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
          <path d="M9 18l6-6-6-6"/>
        </svg>
      </div>
    </div>
  </div>
);